import { useContext, useEffect, useState } from 'react'
import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext'
import { env } from '@/utils/constants/env'
import { axiosInstance } from '@/utils/lib/axios'
import { Dialog, Input, Select } from 'alurkerja-ui'
import { Controller } from 'react-hook-form'

export default function Account() {
  const { setValue, control, taskData } = useContext<CustomComponentContextType>(CustomComponentContext)
  const [loadingAccount, setLoadingAccount] = useState<boolean>(false)
  const [dataAccount, setDataAccount] = useState<{ value: number; label: string }[]>([])

  const classNamesLabel = 'font-medium after:content-["*"] after:text-red-400 after:text-sm'

  useEffect(() => {
    const companyId = taskData?.variables?.company_id_requestor

    const fetchAccount = async () => {
      try {
        setLoadingAccount(true)

        const urlAccount = new URL(env.apiTasklistBaseUrl + '/api/v1/odoo/account?companyId=' + companyId)
        const responseAccount = await axiosInstance.get(urlAccount.toString())
        const optionsAccount = Array.isArray(responseAccount.data.data)
          ? responseAccount.data.data.map((item: { name: string; id: number }) => ({
              value: item.id,
              label: item.name,
            }))
          : []

        setDataAccount(optionsAccount)
        setLoadingAccount(false)
      } catch (error: any) {
        Dialog.error({
          description: error?.response?.data?.data || 'Error fetching account',
        })
      }
    }

    if (companyId) {
      fetchAccount()
    }
  }, [taskData])

  return (
    <div className="flex flex-col gap-4">
      <div>
        <label htmlFor="company" className={classNamesLabel}>
          Company
        </label>
        <Controller
          name={'company'}
          control={control}
          render={({ fieldState }) => {
            return (
              <>
                <Input
                  value={taskData?.variables?.company_requestor ?? ''}
                  disabled
                />
              </>
            )
          }}
        ></Controller>
      </div>

      <div>
        <label className={classNamesLabel}>Account</label>
        <Controller
          name={'ACCOUNT_ID'}
          control={control}
          rules={{ required: { value: true, message: `Account is Required.` } }}
          render={({ fieldState }) => {
            return (
              <>
                <Select
                  isDisabled={dataAccount.length < 1}
                  isLoading={loadingAccount}
                  options={dataAccount}
                  onChange={(newValue: any) => {
                    setValue('ACCOUNT_ID', newValue.value)
                  }}
                />
                {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
              </>
            )
          }}
        ></Controller>
      </div>
    </div>
  )
}
